require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./multnomah-county-juvenile-crime-prevention.json") })
        }
      }, "path---multnomah-county-juvenile-crime-prevention");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---multnomah-county-juvenile-crime-prevention!./.cache/json/multnomah-county-juvenile-crime-prevention.json
// module id = 936
// module chunks = 231608221292675